var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon/comments"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_320_1575",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 29
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.25,
    y: 0.5,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_320_1575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chat_2",
    d: "M7.29167 15.125H14.875V14.0417H7.29167V15.125ZM7.29167 11.875H19.2083V10.7917H7.29167V11.875ZM7.29167 8.625H19.2083V7.54167H7.29167V8.625ZM3.5 22.2501V5.50012C3.5 5.00143 3.66701 4.58507 4.00104 4.25104C4.33507 3.91701 4.75143 3.75 5.25012 3.75H21.2499C21.7486 3.75 22.1649 3.91701 22.499 4.25104C22.833 4.58507 23 5.00143 23 5.50012V17.1665C23 17.6652 22.833 18.0816 22.499 18.4156C22.1649 18.7497 21.7486 18.9167 21.2499 18.9167H6.83342L3.5 22.2501ZM6.37083 17.8333H21.2499C21.4167 17.8333 21.5695 17.7639 21.7084 17.6251C21.8472 17.4862 21.9167 17.3334 21.9167 17.1665V5.50012C21.9167 5.33329 21.8472 5.18045 21.7084 5.0416C21.5695 4.90276 21.4167 4.83333 21.2499 4.83333H5.25012C5.08329 4.83333 4.93045 4.90276 4.7916 5.0416C4.65276 5.18045 4.58333 5.33329 4.58333 5.50012V19.6146L6.37083 17.8333Z",
    fill: "#B2B2B2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentPhoto);
export default __webpack_public_path__ + "static/media/CommentPhoto.70480c7df0971c8cfc1c79f561d1162b.svg";
export { ForwardRef as ReactComponent };